module.exports = __webpack_public_path__ + "static/img/virtualReality2.256d153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality2.png
// module id = uxYX
// module chunks = 13